import axios, {
  AxiosRequestTransformer,
  AxiosResponseTransformer,
} from 'axios';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { isEmpty, get } from 'lodash';
import transform from '../utils/transfrom';
import { HOST } from '../constants/apis';
import { removestore } from './localstore';

const transformResponse: AxiosResponseTransformer = (data) =>
  transform.snakeToCamelcaseTransform(data);
const transformRequest: AxiosRequestTransformer = (data) =>
  JSON.stringify(data);

const requestInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const contentTypes = !isEmpty(get(config, 'headers.Content-Type', ''))
    ? get(config, 'headers.Content-Type', '')
    : 'application/json';
  const configure: AxiosRequestConfig = {
    ...config,
    headers: Object.assign({}, get(config, 'headers', {}), {
      'Content-Type': contentTypes,
    }),
    transformResponse,
    transformRequest,
    params: config.params,
    url: config.url?.replace(/([^:])(\/\/)/g, '$1/'),
  };
  return configure;
};

// const responseInterceptor = (response: AxiosResponse<IResponse>): IResponse => {
//   const successResponse = transform.response(response);
//   return successResponse;
// };

const handleRequestError = (error: any) => {
  return Promise.reject(error);
};

// const handleResponseError = (
//   error: AxiosError<IResponse>
// ): Promise<IResponse> => {
//   const errorResponse = transform.response(error);
//   return Promise.reject(errorResponse);
// };

const axiosInstance: AxiosInstance = axios.create({
  baseURL: HOST.localUrl,

  timeout: 6000,
  responseType: 'json',
});

axiosInstance.defaults.headers.common['Accept'] = 'application/json';
axiosInstance.interceptors.request.use(requestInterceptor, handleRequestError);
// axiosInstance.interceptors.response.use(
//   responseInterceptor,
//   handleResponseError
// );

const LOCAL_TOKEN_KEY = 'renegade';
export const setSession = (accessToken: string | null) => {
  console.log('accessTokenaccessTokenaccessToken', accessToken);

  if (accessToken) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    removestore(LOCAL_TOKEN_KEY);
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};
console.info('Configurated service.');
export default axiosInstance;
